import React from "react";

const Tabs = ({ tabs, active, onChange }) => {
  return (
    <>
      <div className="tab-list">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`tab ${active === tab.id ? "active" : ""}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="panel">{tabs.find((t) => t.id === active)?.content}</div>
    </>
  );
};

export default Tabs;
